import { createAction, props } from '@ngrx/store';
import { ApplicationGlobalizationSettings } from '../../../camms-risk/models/region-settings/application-globalization-settings';

export const setGlobalizationSettings = createAction(
    '[Globalization] Set Globalization Settings',
    props<{ globalizationSettings: ApplicationGlobalizationSettings }>(),
);
